var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActiveNicojinIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1.99994C6.47717 1.99994 2.00002 6.47709 2.00002 11.9999C2.00002 13.5226 2.34101 14.9682 2.95147 16.2621L2.02043 20.7989C1.95286 21.1282 2.05523 21.4694 2.29291 21.707C2.53059 21.9447 2.87178 22.0471 3.20105 21.9795L7.73782 21.0485C9.03181 21.6589 10.4773 21.9999 12 21.9999C17.5229 21.9999 22 17.5228 22 11.9999C22 6.47709 17.5229 1.99994 12 1.99994Z",
    fill: "#2BB1E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveNicojinIcon);
export default __webpack_public_path__ + "static/media/active-nicojin-icon.18fafb6ff4518195062b3bb2917ab470.svg";
export { ForwardRef as ReactComponent };